module.exports = "/_next/static/images/block2-676ba91cf2931884af83f9fed5b3a9f3.svg";